import React, { useEffect } from "react";
import { Button, Form } from "antd";
import { FORM_ART, getDrawerdatenRowEdits } from "../Helper/FormItemElement";

export const EvidenzEmailEdit = ({ handleFinish, editDaten ,handleDelete}) => {
  const [form] = Form.useForm();
  const datenEditProps1 = [
    [
      {
        label: "Titel:",
        feld: "titel",
        place: "Titel",
        // required: "Bitte geben Sie einen Titel ein!",
      },
    ],
    [
      {
        label: "Vorname:", 
        feld: "vorname",
        place: "Vorname",
        // required: "Bitte geben Sie einen Vornamen ein!",
      },
    ],
    [
      {
        label: "Namen:",
        feld: "name",
        place: "Familienname",
        required: "Bitte geben Sie den Familiennamen ein!",
      },
    ],
    [
      {
        label: "Grad:",
        feld: "grad",
        place: "Titel nach Name",
        //required: "Bitte geben Sie den Familiennamen ein!",
      },
    ],
    [
        {
          label: "EMail:",
          feld: "email",
          place: "Email Adresse",
          art:FORM_ART.EMAIL,
          //required: "Bitte geben Sie den Familiennamen ein!",
        },
      ],
    [
      {
        label: "Anrede:",
        feld: "anrede",
        place: "Anrede im EMail",
      },
    ],
    [
      {
        label: "Info:",
        feld: "info",
        place: "Info",
      },
    ],
    [
      {
        label: "Liveupdate",
        feld: "liveupd",
        art: FORM_ART.CHECKBOX,
      },
    ],
    [
        {
          label: "Textemail",
          feld: "textmail",
          art: FORM_ART.CHECKBOX,
        },
      ],
  ];

  useEffect(() => {
    //console.log("editDaten -> sollten gesetzt werden edit", editDaten);
    form.resetFields();
  }, [editDaten, form]);
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        style={{ margin: 0, padding: 0 }}
        initialValues={editDaten}
      >
        {getDrawerdatenRowEdits(datenEditProps1)}
        <br />
        <Form.Item key="submit">
          <Button block type="primary" htmlType="submit">
            Speichern
          </Button>
        </Form.Item>
        <Form.Item key="delete">
          <Button block danger onClick={handleDelete}>
            Datensatz löschen
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
